const initNavbar = () => {
    const navbar = document.querySelector("nav.navbar")
    if (!navbar) return
    const navButton = navbar.querySelector("[data-nav-mobile-menu]")
    navButton.addEventListener("click", () => {
        navbar.classList.toggle("open")
    })
}

export default initNavbar
